<template>
  <div class="ark-model-select" :style="{ '--ark-model-control-width': controlWidth }">
    <el-select
      v-model="selectValue"
      :class="selectClass"
      :size="size"
      @change="handleSelectChange"
    >
      <el-option
        v-for="item in ARK_MODEL_OPTIONS"
        :key="item"
        :label="item"
        :value="item"
      />
      <el-option label="自定义" :value="ARK_MODEL_CUSTOM" />
    </el-select>
    <el-input
      v-if="selectValue === ARK_MODEL_CUSTOM"
      v-model="customValue"
      :class="inputClass"
      :size="size"
      placeholder="输入火山方舟模型 ID"
      clearable
      @input="handleCustomInput"
    />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import {
  ARK_MODEL_CUSTOM,
  ARK_MODEL_OPTIONS,
  resolveArkModelCustomValue,
  resolveArkModelSelectValue
} from '../constants/gmTrainLiePrompt'

export default {
  name: 'ArkModelSelect',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    selectClass: {
      type: String,
      default: 'model-select-wide'
    },
    inputClass: {
      type: String,
      default: 'gs-input'
    },
    controlWidth: {
      type: String,
      default: '320px'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectValue = ref(ARK_MODEL_OPTIONS[0])
    const customValue = ref('')

    const syncFromModel = (model) => {
      selectValue.value = resolveArkModelSelectValue(model)
      customValue.value = resolveArkModelCustomValue(model)
    }

    watch(
      () => props.modelValue,
      (value) => {
        syncFromModel(value)
      },
      { immediate: true }
    )

    const emitModel = () => {
      if (selectValue.value === ARK_MODEL_CUSTOM) {
        emit('update:modelValue', customValue.value.trim())
        return
      }
      emit('update:modelValue', selectValue.value)
    }

    const handleSelectChange = () => {
      emitModel()
    }

    const handleCustomInput = () => {
      if (selectValue.value === ARK_MODEL_CUSTOM) {
        emitModel()
      }
    }

    return {
      ARK_MODEL_OPTIONS,
      ARK_MODEL_CUSTOM,
      selectValue,
      customValue,
      handleSelectChange,
      handleCustomInput
    }
  }
}
</script>

<style scoped>
.ark-model-select {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  max-width: 100%;
}

.ark-model-select :deep(.el-select),
.ark-model-select :deep(.el-input) {
  width: var(--ark-model-control-width, 320px);
  max-width: 100%;
}
</style>
